import React from 'react';
import {createBrowserRouter, Navigate, Outlet} from 'react-router-dom';

import AppProviders from './components/AppProviders';
import ScrollToTop from './components/ScrollToTop';
import Page from './components/shared/page';
import {privateRoutes, publicRoutes, HOME_ROUTE} from './routes';

// Root layout wraps every route with shared providers and scroll behaviour.
// AppProviders and ScrollToTop both rely on useLocation(), so they must live
// inside the router tree — placing them here via <Outlet /> satisfies that.
function RootLayout() {
	return (
		<AppProviders>
			<ScrollToTop />
			<Outlet />
		</AppProviders>
	);
}

// Creates the browser-history router and registers the full route tree.
export const router = createBrowserRouter([
	{
		element: <RootLayout />,
		children: [
			...publicRoutes.map(({path, element}) => ({path, element})),
			// Private routes are wrapped in <Page> for chrome (nav, layout, etc.)
			...privateRoutes.map(({path, element}) => ({
				path,
				element: <Page>{element}</Page>,
			})),
			// Catch-all: redirect unmatched paths to the app home route.
			{
				path: '*',
				element: (
					<Page>
						<Navigate to={HOME_ROUTE} replace />
					</Page>
				),
			},
		],
	},
]);

// Imperative navigation for code outside the React tree (e.g. handleApiError).
// router.navigate() has the same signature as the useNavigate() hook, so
// callers can pass a path string or a To object, plus an optional options arg.
export function navigate(...args) {
	return router.navigate(...args);
}
